import * as React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { createStructuredSelector } from 'reselect';
import { CommandBar, ICommandBarItemProps } from '@fluentui/react';
import { getClassNames } from './index.classNames';
import { DocumentActions as UiDocumentActions} from '../../../redux/actions/ui';
import { CommandActions as DocumentCommandActions} from '../../../redux/actions/document';
import { CommandActions as DocumentsCommandActions} from '../../../redux/actions/documents';
import {Actions as ModalActions} from '@pwbapps/genericdialog';
import _ from 'lodash'
import { getFilterPanelOpened } from '../../../redux/reducers/ui';
import { Document } from '../../../models/document';
import { getTotal } from '../../../redux/reducers/documents';
import { getStatusValues } from '../../../redux/reducers/sharedData';
import { Status } from '../../../models/status';
import { InternalRoleActionsType, ExternalRoleActionsType, isExternalApp } from '../../../utils/costants';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { getContextualDocuments, getSelectedDocument } from '../../../redux/selectors/documents';
import { getSelectedProject } from '../../../redux/selectors/project';
import { Project } from '../../../models/project';
import { getHistoryName } from '../../../utils/functions';
import { withTranslation, WithTranslation  } from 'react-i18next';

export interface ContactsProps extends RouteComponentProps, WithTranslation  {
    filterPanelOpened: boolean, 
    selectedDocuments: Document[],
    total: number,
    loading: boolean,
    loadingContent: boolean,
    loadingScroll: boolean,
    statusValues: Status[],
    selectedDocument?: Document,
    selectedProject?: Project,
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[]
    setFilterPanelOpened: typeof UiDocumentActions.setFilterPanelOpened,
    openEditModal: typeof DocumentsCommandActions.openEditModal,
    setOpenModal: typeof DocumentCommandActions.setOpenModal,
    openGenericModal: typeof ModalActions.CommandActions.openModal,
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
    downloadTemplate: typeof DocumentsCommandActions.downloadTemplate,
}

class DocumentsCommandBar extends React.Component<ContactsProps> {
    constructor(props: ContactsProps) {
        super(props);
    }   


    getButtons = () => {
        const { selectedDocuments, total, openGenericModal, downloadTemplate, fetchDocuments, loadingContent, loading, loadingScroll, statusValues, userProjectActions, selectedDocument, selectedProject, history, t } = this.props;
        let buttons: ICommandBarItemProps[] = [];
        let historyName = getHistoryName(history);
        const commentsExist = (selectedDocuments && selectedDocuments.length > 0) ? _.some(selectedDocuments, d => d.comments && d.comments.length > 0) : true;
        const wrongStatusSelected: boolean = _.some(selectedDocuments, d => d.status && d.status.name !== 'reserved' && d.status.name !== 'supplier-declined');
        
        buttons = [
            ...(isExternalApp && _.find(userProjectActions, a => a === 'ReadReservedNumbers') ? [{
                key: 'batchUpload',
                name: t('Batch Upload'),
                iconProps: {
                    iconName: 'BulkUpload',
                },
                subMenuProps: {
                    items: [
                        {
                            key: 'import',
                            name: t('Import zip'),
                            disabled: (total === 0 || wrongStatusSelected || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'importZip'}) },
                            iconProps: {
                                iconName: 'ZipFolder',
                                style: {color: "#C2891E"}
                            },
                        },
                        {
                            key: 'downloadTemplate',
                            name: t('Download template'),
                            disabled: (total === 0 || wrongStatusSelected || loadingContent || loading || loadingScroll),
                            onClick: () => { downloadTemplate()},
                            iconProps: {
                                iconName: 'ExcelDocument',
                                style: {color: "#008000"}
                            },
                        }
                    ]
                } 
            }] : []), 
            ...(_.find(userProjectActions, a => a === 'ReadReservedNumbers') ? [{
                key: 'downlaod',
                name: t('Download'),
                disabled: (loadingContent || loading || loadingScroll),
                iconProps: {
                    iconName: 'Download',
                },
                subMenuProps: {
                    items: [
                        {
                            key: 'downlaodFiles',
                            name: t('Files'),
                            disabled: (total === 0 || !_.some(selectedDocuments, d => d.files.length > 0) || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'fileName', contextItem: {fileName: 'Documents Files', isParent: false}}) },
                            iconProps:  {
                                iconName: 'DownloadDocument'
                            } 
                        },   
                        {
                            key: 'downloadComments',
                            name: t('Comments'),
                            disabled: (total === 0 || !commentsExist || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'comments', optional: 'Documents Comments'}) },
                            iconProps: {
                                iconName: 'Comment',
                            },
                        }
                    ]
                }          
            }] : []),  
            ...(!isExternalApp ? [{
                key: 'excelReport',
                name: t('Report'),
                disabled: (total === 0 || loadingContent || loading || loadingScroll),
                onClick: () => { openGenericModal({id: 'excelReport', optional: 'Documents Report'}) },
                iconProps: {
                    iconName: 'ExcelDocument',
                    style: {color: "#008000"}
                  },
            }] : []),
            {
                key: 'refresh',
                name: t('Refresh'),
                disabled: (loadingContent || loading || loadingScroll),
                onClick: () => { fetchDocuments({}) },
                iconProps: {
                    iconName: 'Refresh',
                },
            }   
        ]
        return buttons;
    };

    getFarButtons = () => {
      const {setFilterPanelOpened, filterPanelOpened, t} = this.props;
      return [
     
        {
          key: 'openPanel',
          name: t('Filters'),
          iconProps: {
            iconName: 'Filter'
          },
          ariaLabel: 'Filters',    
          onClick: () => {setFilterPanelOpened({open: !filterPanelOpened})}      
        },          
      ]; 
  };

    render() {
        const styles = getClassNames();
        return (
            <>
                <CommandBar
                    styles={{root: styles.root, secondarySet: {borderTop: 1}}}
                    items={this.getButtons()}
                    farItems={this.getFarButtons()}
                />
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    filterPanelOpened: getFilterPanelOpened,
    selectedDocuments: getContextualDocuments,
    total: getTotal,
    statusValues: getStatusValues,
    selectedDocument: getSelectedDocument,
    selectedProject: getSelectedProject
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setFilterPanelOpened: UiDocumentActions.setFilterPanelOpened,
        setOpenModal: DocumentCommandActions.setOpenModal,
        openGenericModal: ModalActions.CommandActions.openModal,
        openEditModal: DocumentsCommandActions.openEditModal,
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
        downloadTemplate: DocumentsCommandActions.downloadTemplate,
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(withRouter(DocumentsCommandBar)));
